import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import { Outlet, Link } from "react-router-dom";
import Button from 'react-bootstrap/esm/Button';
import { useNavigate } from "react-router-dom";


function NavEmp(props) {
  const navigate = useNavigate()

  const fnlogout = () => {
    localStorage.removeItem("jwt");
    props.setLogin(false);
    navigate('/login')
  }

  if (props.isLoggedIn == undefined || !props.isLoggedIn) {
    return (
      <Nav.Link href="#login" ></Nav.Link>
    )
  }
  return (
    <>
      <Navbar expand="lg" className="bg-body-tertiary" bg="light" data-bs-theme="dark">
        <Container>
          <Navbar.Brand>TaskManager</Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="me-auto">
              <Link className="nav-link" to="/tasks/list">Your tasks</Link>
              {/* <Link className="nav-link" to="/employee/edit">Your details</Link> */}
            </Nav>
            <Nav className="justify-content-end" activeKey="/home">
              <Nav.Item>
                <Button variant="primary" onClick={fnlogout}>
                  Logout
                </Button>
              </Nav.Item>
            </Nav>

          </Navbar.Collapse>
        </Container>
      </Navbar>

      <Outlet />
    </>
  );
}

export default NavEmp;